import React, { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { accountAuthError, bootstrapAdmin } from "../api/accountAuthApi";
import PasswordFields, { authButton, authInput, passwordError } from "../components/auth/PasswordFields";

export default function PlatformSetupPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [setupToken, setSetupToken] = useState("");
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [closed, setClosed] = useState(false);
  const [done, setDone] = useState(false);
  if (process.env.REACT_APP_SETUP_MODE !== "true") return <Navigate to="/login" replace />;
  const clearSecrets = () => { setSetupToken(""); setPassword(""); setConfirmation(""); };
  const submit = async (event) => {
    event.preventDefault();
    if (busy) return;
    setError("");
    const problem = passwordError(password, confirmation);
    if (problem) { setError(problem); return; }
    if (!name.trim()) { setError("Name is required."); return; }
    setBusy(true);
    try {
      await bootstrapAdmin({ setup_token: setupToken, name: name.trim(), email: email.trim(), password });
      clearSecrets();
      setDone(true);
    } catch (err) {
      setError(accountAuthError(err));
      if ([404, 409].includes(err.response?.status)) {
        clearSecrets();
        setClosed(true);
      }
    } finally { setBusy(false); }
  };
  return <main className="mx-auto my-12 max-w-lg space-y-5 rounded-xl border bg-white p-6">
    <h1 className="text-2xl font-bold">Initial platform setup</h1>
    {error && <p role="alert" className="text-rose-700">{error}</p>}
    {done ? <p role="status">Your super administrator account has been created. Sign in to continue.</p>
      : !closed && <>
        <p className="text-sm text-slate-600">Create the first super administrator. Setup is allowed only when no user exists and requires the deployment setup key.</p>
        <form onSubmit={submit} className="space-y-4">
          <fieldset disabled={busy} className="space-y-4">
            <label className="block text-sm font-semibold">Setup key
              <input type="password" autoComplete="off" className={authInput} required maxLength={512}
                value={setupToken} onChange={(event) => setSetupToken(event.target.value)} />
            </label>
            <label className="block text-sm font-semibold">Full name
              <input autoComplete="name" className={authInput} required maxLength={200}
                value={name} onChange={(event) => setName(event.target.value)} />
            </label>
            <label className="block text-sm font-semibold">Email
              <input type="email" autoComplete="email" className={authInput} required maxLength={200}
                value={email} onChange={(event) => setEmail(event.target.value)} />
            </label>
            <PasswordFields password={password} confirmation={confirmation} onPassword={setPassword} onConfirmation={setConfirmation} />
            <button className={authButton} disabled={busy}>{busy ? "Creating account..." : "Create super administrator"}</button>
          </fieldset>
        </form>
      </>}
    <Link className="block text-cyan-800 underline" to="/login">Back to sign in</Link>
  </main>;
}
